<script>
import pagination from '../../mixins/pagination';
import {mapGetters} from 'vuex';
export default {
  mixins: [pagination],
  props: {
    size: {
      type: Number,
      required: false,
      default: ACC.allocatedItemsPageSize || 50,
    },
    items: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: '',
    },
    subtotal: {
      type: String,
      default: '',
    },
  },

  inject: ['container'],

  data() {
    return {
      listData: this.items,
    };
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },
  methods: {
    getHeaders() {
      let consumerFriendlyMode = this.consumerFriendlyMode;
      return this.headers.filter((header) => {
        if (consumerFriendlyMode && (header.key === 'unitPrice' || header.key === 'lineSubtotal')) {
          return false;
        } else {
          return true;
        }
      });
    },
  },
  provide() {
    return {
      headers: this.headers,
    };
  },
};
</script>
